<script>
    import { onMount, onDestroy } from "svelte";
    import { page, modal } from '../store/nav';
    import { Datepicker } from 'svelte-calendar';
    import { formatDate } from "../js/helper";
    import Icon from "../components/icon.svelte";

    import { recurring } from "../store/recurring";
    import { items } from "../store/items";
    import { categories } from "../store/categories";

    import { createId, nextDate } from "../js/helper";

    import AutoComplete from "simple-svelte-autocomplete"

    export let item_uid;
    export let list_uid;
    export let store_uid;
    export let store_name;

    //let selectedDate =  new Date(parseInt(selected_date));
    let selectedDate;
    let recurringItem;
    let category = {
        "options": ["organic"],
        "flavors": [],
        "cuts": []
    };

    const dummy = list_uid;    

    onMount(async ()=>{
        const item = await $items.find( i => i.uid == item_uid);
        category = $categories[item.category];
        if ( item.recurringUid ) {
            await recurring.init(item.recurringUid);
            recurringItem = $recurring[0];
            console.log(item, item.recurringUid, recurringItem);
            selectedDate = new Date(parseInt(recurringItem.next));
            items.editSingleField( item_uid, `recurring`, recurringItem.frequency);
        } else {
            selectedDate = nextDate(7);
        }
    });

    const theme = {
        "calendar": {
            "width": "100vw",
            "maxWidth": "100vw",
            "legend": {
            "height": "45px"
            },
            "shadow": "0px 10px 26px rgba(0, 0, 0, 0.25)",
            "colors": {
            "text": {
                "primary": "#222531",
                "highlight": "#FFF"
            },
            "background": {
                "primary": "#fff",
                "highlight": "#ccee3e",
                "hover": "#ccee3e"
            },
            "border": "#eee"
            },
            "font": {
            "regular": "1.5em",
            "large": "20em"
            },
            "grid": {
            "disabledOpacity": ".35",
            "outsiderOpacity": ".6"
            }
        }
    };

    const setItemAsRecurring = async (item, fromFrequency, toFrequency) => {
        console.log(item, store_uid, fromFrequency, toFrequency);

        if ( item.recurringUid ) {
            await recurring.init(item.recurringUid);
            recurringItem = $recurring[0];
        } else {
            await recurring.init();     
            console.log($recurring);
            // Look if any recurring item matches in terms of productUid and storeUid 
            recurringItem = await $recurring.find( r => (item.productUid == r.productUid && store_uid == r.storeUid && item.cut == r.cut));
            if ( recurringItem ) recurring.editSingleField(recurringItem.uid, `itemInList`, item_uid);      
        }
        console.log(recurringItem);
        
        // If user is marking the item as recurring 
        if ( fromFrequency === false && toFrequency !== false) {
            console.log(`[RECURRING] New item`);
            if ( !recurringItem ){
                const newUid = createId.uuid();
                const newRecurring = {
                    "uid":newUid,
                    "name":item.name,
                    "productUid":item.productUid,
                    "category":item.category,
                    "qty":item.qty,
                    "unit":item.unit,
                    "storeUid":store_uid,
                    "storeName":store_name,
                    "itemInList":item.uid,
                    "frequency":toFrequency,
                    "next":selectedDate,
                    "options":item.options,
                    "cut":item.cut,
                    "details":item.detail
                }
                recurring.add(newRecurring);
                recurringItem = newRecurring;
                items.editSingleField(item.uid, `recurringUid`, newUid);
            }
        // If the user goes from recurring to non recurring    
        } else if ( fromFrequency !==false && toFrequency === false ) {
            console.log(`[RECURRING] Delete item`);
            if (recurringItem) recurring.delete(recurringItem.uid);
            if ( item.recurringUid ) item.recurringUid = null;
        // Otherwise user is just changin the frequency of a recurring item
        } else {
            console.log(`[RECURRING] Change item`,recurringItem, item);
            if ( recurringItem ) recurring.editSingleField(recurringItem.uid, `frequency`, toFrequency);
            if ( ! item.recurringUid ) item.recurringUid = recurringItem.uid;
        }
    };

    const syncNextDate = () => {
        console.log(recurringItem);
        if(recurringItem) recurring.editSingleField(recurringItem.uid,`next`, Date.parse(selectedDate))
    };

    const deleteRecurringItem = async i => {
        modal.close();
        items.delete(i.uid);
    }

    $:selectedDate,syncNextDate();
</script>
<section >
    {#each $items as item}
    {#if item.uid == item_uid}
        <div class="bg-primary absolute rounded-2xl w-12 h-12 shrink-0 top-5 right-5">
            <img class="m-auto w-8 h-8 mt-2" src="/img/icon/food/{item.category}.png" alt="">
        </div>

        <section class="text-primary flex flex-col space-y-2">
            <span class="text-2xl ">{item.name}</span>
            <section class="flex space-x-1">
                <span>Qty: </span>
                <input class="ml-1.5 border-b border-shade w-16 text-center" type="text" name="" id="" bind:value={item.qty}>
                <div on:click|stopPropagation={()=>{if((item.qty-1) >= 0) {item.qty--}else{item.qty=0}}}>
                    <Icon class="w-4 place-self-center" name="minus-insquare-dark"/>
                </div>
                <div on:click|stopPropagation={()=>item.qty++}>
                    <Icon class="w-4 place-self-center" name="plus-insquare-dark"/>
                </div>
                
            </section>
            <section class="flex space-x-2.5">
                <span>Unit: </span>
                <select class="border border-shade px-2 rounded-sm w-24 capitalize text-sm italic place-self-center" id="unit" bind:value={item.unit}>
                    <option value="lbs">lbs</option>
                    <option value="oz">oz</option>
                    <option value="gal">Gallon</option>
                    <option value="qt">Quart</option>
                    <option value="pt">Pint</option>
                    <option value="bag">Bag</option>
                    <option value="bunch">Bunch</option>
                    <option value="">Unit</option>
                    <!--
                        0: "COUNT"
                        1: "CLOVES"
                        2: "SLICES"
                        3: "STALKS"
                        4: "LEAVES"
                        5: "BUNCHES"
                        6: "KILOGRAMS"
                        7: "GRAMS"
                        8: "POUNDS"
                        9: "OUNCES"
                        10: "PINCHES"
                        11: "LITERS"
                        12: "CENTILITERS"
                        13: "MILLILITERS"
                        14: "CC"
                        15: "DROPS"
                        16: "GALLONS"
                        17: "QUARTS"
                        18: "PINTS"
                        19: "CUPS"
                        20: "FL_OZ"
                        21: "HEAPING_TBSP"
                        22: "TBSP"
                        23: "HEAPING_TSP"
                        24: "TSP"
                    -->
                </select>
            </section>
            {#if category.cuts.length > 0 }
                <section class="flex space-x-2.5">
                    <span>Cut: </span>
                    <AutoComplete className="capitalize text-primary " inputClassName="capitalize border border-shade text-primary text-ellipsis overflow-hidden" hideArrow={true} items="{category.cuts}" bind:selectedItem="{item.cut}" />
                </section>
            {/if}
            <section class="flex space-x-2.5 flex-wrap">
                {#each item.options as options }
                    {#each Object.entries(options) as [optionKey, optionValue] }
                        <span class:selected={options[optionKey]} class="border border-shade mt-1.5 px-2 rounded-sm  min-w-16 capitalize text-sm italic place-self-center" on:click={()=>{if(options[optionKey]){options[optionKey]=false}else{options[optionKey]=true}}}>{optionKey}</span>
                    {/each}                
                {/each}
            </section>
            <section class="flex">
                <span>Details: </span>
                <input class="ml-2.5 border-b border-shade min-w-16" id="details" bind:value={item.details}>
            </section>
            <span class="text-secondary">-</span>
            <span class="">Make this item recurring</span>
            <section class="flex space-x-2">
                <span class:selected={!item.recurring} class="border border-shade p-2 rounded-sm capitalize text-sm italic" on:click={ ()=> {setItemAsRecurring(item, item.recurring, false);item.recurring=false;}}>no</span>
                <span class:selected={item.recurring==`weekly`} class="border border-shade p-2 rounded-sm capitalize text-sm italic" on:click={()=>{setItemAsRecurring(item, item.recurring, `weekly`);item.recurring=`weekly`;}}>weekly</span>
                <span class:selected={item.recurring==`other w`} class="border border-shade p-2 rounded-sm capitalize text-sm italic" on:click={()=>{setItemAsRecurring(item, item.recurring, `other w`);item.recurring=`other w`;}}>other w</span>
                <span class:selected={item.recurring==`monthly`} class="border border-shade p-2 rounded-sm capitalize text-sm italic" on:click={()=>{setItemAsRecurring(item, item.recurring, `monthly`);item.recurring=`monthly`;}}>monthly</span>
                <span class:selected={item.recurring==`quaterly`} class="border border-shade p-2 rounded-sm capitalize text-sm italic" on:click={()=>{setItemAsRecurring(item, item.recurring, `quaterly`);item.recurring=`quaterly`;}}>quaterly</span>
            </section>
            <span class:disabled={!item.recurring}>Pick next date:</span>
            <section >
                <Datepicker bind:selected={selectedDate} let:key let:send let:receive {theme}>
                    <button class:disabled={!item.recurring} disabled={!item.recurring} class="border border-shade p-2 rounded-sm capitalize text-sm italic" in:receive|local={{ key }} out:send|local={{ key }} >
                        {#if item.recurring}
                            {formatDate.md(selectedDate)}
                        {:else}
                            n/a
                        {/if}
                    </button>
                </Datepicker>
            </section>
            <section class="self-end text-shade italic text-sm" on:click={()=>deleteRecurringItem(item)}>
                Delete
            </section>
        </section>
    {/if}
    {/each}
</section>
<style lang="postcss">
    .selected {
        @apply border-secondary text-secondary bg-primary;
    }
    .disabled {
        @apply text-shade italic;
    }
</style>